/* FansBRANDS Order Support Core V20.3
 * Shared validation + customer-facing order status renderer.
 * Used by both the Help Center and the floating support chat.
 */
(function () {
  'use strict';

  if (window.FansBrandsOrderSupport) return;

  var FIELD_META = {
    order_number: {
      label: 'Číslo objednávky',
      short: 'Číslo objednávky',
      prompt: 'Zadejte číslo objednávky',
      hint: 'Najdete ho v potvrzovacím e-mailu. Příklad: CZ12345.',
      placeholder: 'CZ12345',
      type: 'text',
      inputMode: 'text',
      autocomplete: 'off',
      maxLength: 40
    },
    email: {
      label: 'E-mailová adresa',
      short: 'E-mailová adresa',
      prompt: 'Zadejte e-mail použitý v objednávce',
      hint: 'Zadejte stejný e-mail, který jste uvedli v objednávce.',
      placeholder: 'jmeno@email.cz',
      type: 'email',
      inputMode: 'email',
      autocomplete: 'email',
      maxLength: 254
    },
    phone: {
      label: 'Telefonní číslo',
      short: 'Telefonní číslo',
      prompt: 'Zadejte telefonní číslo uvedené v objednávce',
      hint: 'Včetně předvolby země. Příklad: +420 777 123 456.',
      placeholder: '+420 777 123 456',
      type: 'tel',
      inputMode: 'tel',
      autocomplete: 'tel',
      maxLength: 32
    },
    postal_code: {
      label: 'PSČ',
      short: 'PSČ',
      prompt: 'Zadejte PSČ z objednávky',
      hint: 'Zadejte PSČ doručovací nebo fakturační adresy.',
      placeholder: '110 00',
      type: 'text',
      inputMode: 'text',
      autocomplete: 'postal-code',
      maxLength: 16
    }
  };

  function cleanText(value) {
    return String(value || '')
      .replace(/[\u00A0\u2000-\u200D\u202F\u205F\u3000]/g, ' ')
      .trim();
  }

  function normalize(type, value) {
    var raw = cleanText(value);

    if (type === 'order_number') {
      var upper = raw.toUpperCase();
      var embedded = upper.match(/CZ[\s#-]*\d{2,}/i);
      if (embedded) return embedded[0].replace(/[\s#-]+/g, '').toUpperCase();
      return upper.replace(/^#+/, '').replace(/\s+/g, '');
    }

    if (type === 'email') {
      return raw.replace(/\s+/g, '').toLowerCase();
    }

    if (type === 'phone') {
      var compact = raw.replace(/[\s().\-\/]/g, '');
      if (!/^[+\d]+$/.test(compact)) return compact;
      if (/^00\d+/.test(compact)) compact = '+' + compact.slice(2);
      if (/^\d{9}$/.test(compact)) compact = '+420' + compact;
      if (/^420\d{9}$/.test(compact)) compact = '+' + compact;
      return compact;
    }

    if (type === 'postal_code') {
      return raw.replace(/[\s-]+/g, '');
    }

    return raw;
  }

  function isFansBrandsInternalEmail(email) {
    var normalizedEmail = normalize('email', email);
    var parts = normalizedEmail.split('@');
    if (parts.length !== 2) return false;

    var domain = String(parts[1] || '').toLowerCase().replace(/\.$/, '');
    if (!domain) return false;

    // Tiltjuk a FansBRANDS saját e-mail domainjeit minden piacon,
    // valamint azok aldomainjeit (pl. mail.fansbrands.hu).
    return domain.indexOf('fansbrands.') === 0 || domain.indexOf('.fansbrands.') !== -1;
  }

  function emailTypoSuggestion(email) {
    var parts = email.split('@');
    if (parts.length !== 2) return '';
    var domain = (parts[1] || '').toLowerCase();
    var known = {
      'gamil.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com',
      'gmail.co': 'gmail.com', 'gmail.cz': 'gmail.com', 'hotnail.com': 'hotmail.com',
      'hotmai.com': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'outlok.com': 'outlook.com',
      'outllok.com': 'outlook.com', 'outlook.co': 'outlook.com', 'yaho.com': 'yahoo.com',
      'yahoo.co': 'yahoo.com', 'icloud.co': 'icloud.com'
    };
    return known[domain] || '';
  }

  function validate(type, value) {
    var v = normalize(type, value);

    if (!v) return { error: 'Vyplňte toto pole.', value: '' };

    if (type === 'order_number') {
      if (v.indexOf('@') !== -1) return { error: 'Zřejmě jste místo čísla objednávky zadali e-mail.', value: v };
      if (v.length < 3 || v.length > 40 || !/^[A-Z0-9_-]+$/.test(v)) {
        return { error: 'Nesprávný formát čísla objednávky. Příklad: CZ12345.', value: v };
      }
    }

    if (type === 'email') {
      if (v.length > 254) return { error: 'Zadaný e-mail je příliš dlouhý.', value: v };
      if ((v.match(/@/g) || []).length !== 1 || !/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(v)) {
        return { error: 'Nesprávný formát e-mailu. Příklad: jmeno@email.cz.', value: v };
      }
      if (isFansBrandsInternalEmail(v)) {
        return {
          error: 'Použijte osobní e-mail z objednávky, nikoli interní adresu FansBRANDS.',
          value: v
        };
      }

      var suggestion = emailTypoSuggestion(v);
      if (suggestion) {
        var local = v.split('@')[0];
        return { error: 'Možná jste zadali chybnou doménu. Mysleli jste: ' + local + '@' + suggestion + '?', value: v };
      }
    }

    if (type === 'phone') {
      if (/[A-Za-zÁČĎÉĚÍŇÓŘŠŤÚŮÝŽáčďéěíňóřšťúůýž]/.test(v)) {
        return { error: 'Telefonní číslo nesmí obsahovat písmena.', value: v };
      }
      if (!/^\+\d{8,15}$/.test(v)) {
        var digits = String(value || '').replace(/\D/g, '');
        if (/^\d{9}$/.test(digits)) {
          return { error: 'Chybí mezinárodní předvolba. Příklad: +420 777 123 456.', value: v };
        }
        return { error: 'Zadejte číslo s předvolbou. Příklad: +420 777 123 456.', value: v };
      }
    }

    if (type === 'postal_code') {
      if (!/^\d{5}$/.test(v)) {
        return { error: 'Nesprávný formát PSČ.', value: v };
      }
    }

    return { error: '', value: v };
  }

  function secondaryKeys(primary) {
    if (primary === 'order_number') return ['email', 'phone', 'postal_code'];
    if (primary === 'email') return ['order_number', 'phone', 'postal_code'];
    return [];
  }

  function configureInput(input, type) {
    var meta = FIELD_META[type];
    if (!input || !meta) return;
    input.type = meta.type;
    input.inputMode = meta.inputMode;
    input.autocomplete = meta.autocomplete;
    input.maxLength = meta.maxLength;
    input.placeholder = meta.placeholder;
    input.autocapitalize = type === 'order_number' ? 'characters' : 'none';
    input.spellcheck = false;
    input.value = '';
  }

  function safeUrl(value) {
    if (typeof value !== 'string' || !value) return '';
    try {
      var u = new URL(value);
      return u.protocol === 'https:' && !u.username && !u.password ? u.href : '';
    } catch (_) {
      return '';
    }
  }

  function upper(value) { return String(value || '').toUpperCase(); }

  function pragueDateParts(value) {
    if (!value) return null;
    var date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return null;
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(date);
      var out = {};
      parts.forEach(function (p) { if (p.type !== 'literal') out[p.type] = p.value; });
      return { year: Number(out.year), month: Number(out.month), day: Number(out.day) };
    } catch (_) {
      return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
  }

  function ymd(parts) {
    if (!parts) return '';
    return String(parts.year).padStart(4, '0') + '-' + String(parts.month).padStart(2, '0') + '-' + String(parts.day).padStart(2, '0');
  }

  function partsFromYmd(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
    return m ? { year: Number(m[1]), month: Number(m[2]), day: Number(m[3]) } : null;
  }

  function utcDateFromParts(parts) {
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  }

  function addCalendarDays(parts, days) {
    var d = utcDateFromParts(parts);
    d.setUTCDate(d.getUTCDate() + days);
    return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
  }

  function easterSundayParts(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return { year: year, month: month, day: day };
  }

  // České státní svátky a ostatní dny pracovního klidu.
  function czechHolidaySet(year) {
    var days = [year + '-01-01', year + '-05-01', year + '-05-08', year + '-07-05',
      year + '-07-06', year + '-09-28', year + '-10-28', year + '-11-17',
      year + '-12-24', year + '-12-25', year + '-12-26'];
    var easter = easterSundayParts(year);
    days.push(ymd(addCalendarDays(easter, -2))); // Velký pátek
    days.push(ymd(addCalendarDays(easter, 1))); // Velikonoční pondělí
    return new Set(days);
  }

  function isCzechWorkday(parts) {
    var day = utcDateFromParts(parts).getUTCDay();
    if (day === 0 || day === 6) return false;
    return !czechHolidaySet(parts.year).has(ymd(parts));
  }

  function nextCzechWorkday(parts) {
    var cur = addCalendarDays(parts, 1);
    while (!isCzechWorkday(cur)) cur = addCalendarDays(cur, 1);
    return cur;
  }

  function addCzechWorkdays(parts, count) {
    var cur = { year: parts.year, month: parts.month, day: parts.day };
    var added = 0;
    while (added < count) {
      cur = addCalendarDays(cur, 1);
      if (isCzechWorkday(cur)) added += 1;
    }
    return cur;
  }

  function compareParts(a, b) {
    return utcDateFromParts(a).getTime() - utcDateFromParts(b).getTime();
  }

  function businessDaysInclusive(start, end) {
    if (compareParts(start, end) > 0) return 0;
    var cur = { year: start.year, month: start.month, day: start.day };
    var count = 0;
    while (compareParts(cur, end) <= 0) {
      if (isCzechWorkday(cur)) count += 1;
      cur = addCalendarDays(cur, 1);
    }
    return count;
  }

  function calendarDaysRemaining(today, deadline) {
    return Math.max(0, Math.ceil((utcDateFromParts(deadline) - utcDateFromParts(today)) / 86400000));
  }

  function pickupModel(data) {
    data = data || {};
    var readySource = data.pickupReadyAt || (upper(data.deliveryStatus) === 'READY_FOR_PICKUP' ? data.deliveryHappenedAt : null);
    var ready = pragueDateParts(readySource);
    var mode = String(data.pickupRetentionMode || '');
    var days = Number(data.pickupRetentionDays || 0);
    var type = String(data.pickupType || '');
    if (!ready || !mode || !days || (type !== 'parcel_point' && type !== 'locker')) return null;

    var deadline = mode === 'business' ? addCzechWorkdays(ready, days) : addCalendarDays(ready, days);
    var today = pragueDateParts(new Date());
    if (!today) return null;

    var expired = compareParts(today, deadline) > 0;
    var remaining;
    var unit;

    if (mode === 'business') {
      var firstCounted = nextCzechWorkday(ready);
      var start = compareParts(today, firstCounted) < 0 ? firstCounted : today;
      remaining = expired ? 0 : businessDaysInclusive(start, deadline);
      unit = remaining === 1 ? 'pracovní den' : 'pracovní dny';
    } else {
      remaining = expired ? 0 : calendarDaysRemaining(today, deadline);
      unit = remaining === 1 ? 'den' : 'dní';
    }

    return {
      type: type,
      label: data.pickupLabel || (type === 'locker' ? 'Locker' : 'Výdejní místo'),
      mode: mode,
      days: days,
      readyDate: ymd(ready),
      deadlineDate: ymd(deadline),
      remaining: remaining,
      unit: unit,
      expired: expired,
      urgent: !expired && remaining <= 1
    };
  }

  function statusModel(data) {
    data = data || {};
    var delivery = upper(data.deliveryStatus);
    var fulfillment = upper(data.fulfillmentStatus);
    var carrierName = (data.tracking && data.tracking.company) || data.carrier || '';
    var carrierPage = carrierName ? carrierName + ' na stránce sledování zásilky' : 'stránka sledování přepravce';

    if (data.cancelled) {
      return {
        key: 'cancelled', tone: 'red', label: 'Objednávka zrušena',
        message: 'Objednávka byla zrušena; nebude připravena ani doručena.',
        problem: true, showTracking: false
      };
    }

    if (delivery === 'ATTEMPTED_DELIVERY') {
      return {
        key: 'attempted_delivery', tone: 'red', label: 'Neúspěšné doručení',
        message: 'Přepravce se pokusil zásilku doručit, ale doručení se nezdařilo. Podrobnosti najdete na ' + carrierPage + ', nebo kontaktujte podporu.',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'FAILURE' || delivery === 'NOT_DELIVERED' || delivery === 'CANCELED') {
      return {
        key: 'delivery_problem', tone: 'red', label: 'Problém při doručování',
        message: 'Přepravce nahlásil problém s doručením. Podrobnosti najdete na ' + carrierPage + ', nebo nás kontaktujte.',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'DELAYED') {
      return {
        key: 'delayed', tone: 'red', label: 'Zpožděná zásilka',
        message: 'Přepravce nahlásil zpoždění. Aktuální informace najdete na ' + carrierPage + ' .',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'DELIVERED') {
      return {
        key: 'delivered', tone: 'green', label: 'Livrat',
        message: 'Podle přepravce byla zásilka doručena. Pokud jste ji neobdrželi, kontaktujte nás.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'OUT_FOR_DELIVERY') {
      return {
        key: 'out_for_delivery', tone: 'blue', label: 'Doručuje se',
        message: 'Zásilka je na doručovací trase. DŮLEŽITÉ: na webu přepravce najdete nejnovější informace a případně časové okno doručení. Ujistěte se, že zásilku můžete převzít.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'IN_TRANSIT' || delivery === 'CARRIER_PICKED_UP') {
      return {
        key: 'in_transit', tone: 'blue', label: 'Na cestě k vám',
        message: 'Zásilku převzal přepravce. DŮLEŽITÉ: aktuální informace a předpokládané doručení najdete na webu přepravce. Pokud je doručení plánované na dnes, připravte se na převzetí.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'READY_FOR_PICKUP') {
      var pickup = pickupModel(data);
      if (pickup && pickup.expired) {
        return {
          key: 'pickup_expired', tone: 'red', label: 'Lhůta pro vyzvednutí uplynula',
          message: 'Lhůta pro vyzvednutí uplynula; zásilka může být vrácena odesílateli. Zkontrolujte stránku přepravce nebo nás kontaktujte.',
          problem: true, showTracking: true
        };
      }
      return {
        key: 'ready_for_pickup', tone: 'blue', label: 'Připraveno k vyzvednutí',
        message: pickup
          ? 'Vaše zásilka dorazila na ' + pickup.label + ' k vyzvednutí. Vyzvedněte si ji včas.'
          : 'Zásilka je připravena k vyzvednutí. Podrobnosti najdete v oznámení přepravce.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'PICKED_UP') {
      return {
        key: 'picked_up', tone: 'green', label: 'Ridicat',
        message: 'Podle systému byla zásilka vyzvednuta. Pokud to není správně, kontaktujte nás.',
        problem: false, showTracking: false
      };
    }

    if (delivery === 'LABEL_VOIDED') {
      return {
        key: 'label_voided', tone: 'yellow', label: 'Příprava odeslání',
        message: 'Původní přepravní štítek byl zrušen. Objednávku stále zpracováváme.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'FULFILLED' || delivery === 'FULFILLED' || delivery === 'MARKED_AS_FULFILLED' || delivery === 'LABEL_PRINTED' || delivery === 'LABEL_PURCHASED' || delivery === 'CONFIRMED' || delivery === 'SUBMITTED') {
      return {
        key: 'packed', tone: 'yellow', label: 'Ambalat',
        message: 'Objednávka je připravena. Následuje předání přepravci.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'IN_PROGRESS') {
      return {
        key: 'packing', tone: 'yellow', label: 'Připravuje se',
        message: 'Objednávku připravujeme; nyní není třeba nic dělat.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'PARTIALLY_FULFILLED') {
      return {
        key: 'partially_packed', tone: 'yellow', label: 'Částečně připravena',
        message: 'Část objednávky je připravena. Při více zásilkách můžete dostat několik oznámení.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'ON_HOLD') {
      return {
        key: 'on_hold', tone: 'yellow', label: 'Probíhá kontrola',
        message: 'Objednávku ověřujeme. Pokud se stav nemění, kontaktujte nás.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'FULFILLMENT_NOT_REQUIRED') {
      return {
        key: 'no_shipping', tone: 'yellow', label: 'Není potřeba odesílat',
        message: 'Tato objednávka nevyžaduje odeslání fyzické zásilky.',
        problem: false, showTracking: false
      };
    }

    return {
      key: 'processing', tone: 'yellow', label: 'Zpracovává se',
      message: 'Objednávku jsme přijali a zpracováváme ji. Nyní nemusíte nic dělat.',
      problem: false, showTracking: false
    };
  }

  function paymentMethodLabel(name) {
    var raw = String(name || '').trim();
    if (!raw) return '';
    if (/^shopify[_\s-]*payments$/i.test(raw)) return 'Card bancar';
    return raw;
  }

  function paymentModel(data) {
    data = data || {};
    var status = upper(data.financialStatus);
    var gateways = Array.isArray(data.paymentGatewayNames) ? data.paymentGatewayNames.filter(Boolean) : [];
    var isCod = data.isCod === true || gateways.some(function (name) {
      return /cash\s*on\s*delivery|\bcod\b|ramburs|plata la livrare|ut[aá]nv[eé]t/i.test(String(name));
    });
    var method = isCod ? 'Ramburs' : paymentMethodLabel(gateways[0]);

    if (isCod && status === 'PENDING') {
      var pickupType = String(data.pickupType || '').toLowerCase();
      var codMessage = pickupType
        ? 'Zaplatíte při vyzvednutí. Ověřte dostupné způsoby platby na výdejním místě.'
        : 'Zaplatíte při doručení hotově nebo kartou podle možností přepravce.';
      return {
        key: 'cod', label: 'Ramburs', method: 'Ramburs',
        message: codMessage
      };
    }
    if (status === 'PAID') return { key: 'paid', label: 'Fizetve', method: method, message: 'Nemáte žádné další platby.' };
    if (status === 'AUTHORIZED') return { key: 'authorized', label: 'Platba autorizována', method: method, message: 'Platba byla autorizována. Nemusíte nic dělat.' };
    if (status === 'PARTIALLY_PAID') return { key: 'partial', label: 'Částečně zaplaceno', method: method, message: 'Zaplacena je pouze část objednávky.' };
    if (status === 'REFUNDED') return { key: 'refunded', label: 'Vráceno', method: method, message: 'Částka byla vrácena.' };
    if (status === 'PARTIALLY_REFUNDED') return { key: 'partial_refund', label: 'Částečně vráceno', method: method, message: 'Část objednávky byla refundována.' };
    if (status === 'VOIDED') return { key: 'voided', label: 'Zrušeno', method: method, message: 'Platba byla zrušena.' };
    if (status === 'EXPIRED') return { key: 'expired', label: 'Plata a expirat', method: method, message: 'Platba nebyla dokončena včas. Pokud potřebujete pomoc, kontaktujte nás.' };
    if (status === 'PENDING') return { key: 'pending', label: 'Čeká na platbu', method: method, message: 'Platba zatím nebyla dokončena. Pokud je to neočekávané, kontaktujte nás.' };
    return { key: 'unknown', label: 'Platba', method: method, message: 'Údaje o platbě nejsou nyní dostupné.' };
  }

  function formatDate(value) {
    if (!value) return '–';
    try {
      return new Intl.DateTimeFormat('cs-CZ', { year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(value));
    } catch (_) { return String(value); }
  }

  function formatMoney(money) {
    if (!money || money.amount == null) return '–';
    var currency = money.currencyCode || 'CZK';
    try {
      return new Intl.NumberFormat('cs-CZ', {
        style: 'currency', currency: currency, maximumFractionDigits: currency === 'CZK' ? 2 : 2
      }).format(Number(money.amount));
    } catch (_) {
      return money.amount + ' ' + currency;
    }
  }

  function el(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  function whatsappUrl(baseUrl, data, status) {
    var safe = safeUrl(baseUrl);
    if (!safe) return '';
    try {
      var u = new URL(safe);
      var message = 'Dobrý den, potřebuji pomoc s objednávkou';
      if (data && data.name) message += ' ' + data.name;
      if (status && status.label) message += '. Stare: ' + status.label;
      message += '.';
      u.searchParams.set('text', message);
      return u.href;
    } catch (_) { return safe; }
  }

  function appendWhatsApp(container, baseUrl, data, status, strong) {
    var href = whatsappUrl(baseUrl, data, status);
    if (!href) return;
    var a = el('a', strong ? 'fb-order-whatsapp is-strong' : 'fb-order-whatsapp', strong ? 'KONTAKTOVAT PODPORU' : 'Máte dotaz? Kontaktujte nás');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    container.appendChild(a);
  }

  function formatDateOnly(value) {
    var p = partsFromYmd(value);
    if (!p) return 'Zatím nejsou dostupné údaje';
    try {
      return new Intl.DateTimeFormat('cs-CZ', {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
      }).format(utcDateFromParts(p));
    } catch (_) { return value; }
  }

  function appendPickupCountdown(container, data, status, options) {
    if (upper(data.deliveryStatus) !== 'READY_FOR_PICKUP') return;
    var pickup = pickupModel(data);
    if (!pickup) return;

    var box = el('div', 'fb-order-view__pickup' + (pickup.expired ? ' is-expired' : (pickup.urgent ? ' is-urgent' : '')));
    var top = el('div', 'fb-order-view__pickup-top');
    var copy = el('div');
    copy.appendChild(el('span', '', pickup.label === 'GLS box' ? 'LHŮTA VYZVEDNUTÍ – GLS BOX' : 'LHŮTA VYZVEDNUTÍ – VÝDEJNÍ MÍSTO GLS'));
    copy.appendChild(el('strong', '', pickup.expired ? 'Lhůta pro vyzvednutí uplynula' : ('Zbývá ' + pickup.remaining + ' ' + pickup.unit + ' k vyzvednutí')));
    top.appendChild(copy);
    box.appendChild(top);

    var dates = el('div', 'fb-order-view__pickup-dates');
    var arrived = el('div');
    arrived.appendChild(el('span', '', 'Doručeno na výdejní místo'));
    arrived.appendChild(el('strong', '', formatDateOnly(pickup.readyDate)));
    var deadline = el('div');
    deadline.appendChild(el('span', '', 'Lhůta k vyzvednutí'));
    deadline.appendChild(el('strong', '', formatDateOnly(pickup.deadlineDate)));
    dates.append(arrived, deadline);
    box.appendChild(dates);

    var noteWrap = el('div', 'fb-order-view__pickup-note');
    noteWrap.appendChild(el('p', '', pickup.mode === 'business'
      ? 'Na výdejním místě GLS bývá lhůta k vyzvednutí 5 pracovních dnů (ověřte oznámení přepravce).'
      : 'V boxu GLS bývá úložní doba 7 kalendářních dnů (ověřte oznámení přepravce).'));
    var important = el('p', 'fb-order-view__pickup-important');
    important.appendChild(el('strong', 'fb-order-important', 'IMPORTANT:'));
    important.appendChild(document.createTextNode(' Termenul comunicat de GLS este cel aplicabil.'));
    noteWrap.appendChild(important);
    box.appendChild(noteWrap);

    container.appendChild(box);
  }

  function appendStatusMessage(container, status, data) {
    var box = el('div', 'fb-order-view__message fb-order-view__message--structured');

    function addParagraph(text, className) {
      if (!text) return;
      box.appendChild(el('p', className || '', text));
    }

    function addImportant(text) {
      var p = el('p', 'fb-order-view__important-line');
      p.appendChild(el('strong', 'fb-order-important', 'IMPORTANT:'));
      p.appendChild(document.createTextNode(' ' + text));
      box.appendChild(p);
    }

    if (status.key === 'in_transit') {
      addParagraph('Zásilku převzal přepravce.', 'fb-order-view__message-title');
      addImportant('Aktuální informace a případný čas doručení najdete na webu přepravce.');
      addParagraph('Pokud je doručení plánováno dnes, zajistěte převzetí.');
    } else if (status.key === 'out_for_delivery') {
      addParagraph('Zásilka je v doručování.', 'fb-order-view__message-title');
      addImportant('Zkontrolujte očekávaný čas doručení na webu přepravce.');
      addParagraph('Zajistěte převzetí zásilky na uvedené adrese.');
    } else if (status.key === 'ready_for_pickup') {
      addParagraph('Zásilka je připravena k vyzvednutí.', 'fb-order-view__message-title');
      addImportant('Vyzvedněte zásilku do termínu uvedeného přepravcem.');
    } else if (status.key === 'pickup_expired') {
      addParagraph('Lhůta pro vyzvednutí uplynula.', 'fb-order-view__message-title');
      addImportant('Zásilka může být vrácena odesílateli.');
      addParagraph('Zkontrolujte stránku přepravce nebo kontaktujte podporu.');
    } else if (status.key === 'attempted_delivery' || status.key === 'delivery_problem' || status.key === 'delayed') {
      addParagraph(status.message, 'fb-order-view__message-title');
      addImportant('Sledujte zásilku na webu přepravce; pokud potřebujete pomoc, kontaktujte nás.');
    } else {
      addParagraph(status.message);
    }

    container.appendChild(box);
  }

  function renderOrder(container, data, options) {
    options = options || {};
    if (!container) return;
    var status = statusModel(data);
    var payment = paymentModel(data);
    var tracking = data && data.tracking ? data.tracking : {};
    var trackingUrl = safeUrl(tracking.url);
    var carrier = tracking.company || data.carrier || '';

    container.replaceChildren();
    container.classList.add('fb-order-view');

    var head = el('div', 'fb-order-view__head');
    var id = el('div', 'fb-order-view__identity');
    id.appendChild(el('span', 'fb-order-view__eyebrow', 'OBJEDNÁVKA'));
    id.appendChild(el('strong', 'fb-order-view__name', data.name || 'Objednávka'));
    head.appendChild(id);
    head.appendChild(el('span', 'fb-order-badge is-' + status.tone, status.label));
    container.appendChild(head);

    appendStatusMessage(container, status, data);

    if (data.cancelled) {
      appendWhatsApp(container, options.whatsappUrl, data, status, true);
      container.hidden = false;
      return;
    }

    var meta = el('div', 'fb-order-view__meta');
    var dateBox = el('div', 'fb-order-view__meta-item');
    dateBox.appendChild(el('span', '', 'Datum objednávky'));
    dateBox.appendChild(el('strong', '', formatDate(data.processedAt || data.createdAt)));
    var totalBox = el('div', 'fb-order-view__meta-item');
    totalBox.appendChild(el('span', '', 'Hodnota objednávky'));
    totalBox.appendChild(el('strong', '', formatMoney(data.total)));
    meta.append(dateBox, totalBox);

    var pickup = pickupModel(data);
    var pickupReadySource = data.pickupReadyAt || (upper(data.deliveryStatus) === 'READY_FOR_PICKUP' ? data.deliveryHappenedAt : null);
    var isReadyPickup = upper(data.deliveryStatus) === 'READY_FOR_PICKUP' && !!pickupReadySource;
    var isDelivered = status.key === 'delivered' || upper(data.deliveryStatus) === 'DELIVERED';
    var deliveredSource = data.deliveredAt || (isDelivered ? data.deliveryHappenedAt : null);

    var expectedLabel = '';
    var expectedValue = '';

    // Csak ténylegesen rendelkezésre álló dátumot mutatunk.
    // A Shopify a GLS várható kézbesítési idejét nem feltétlenül adja át.
    if (isDelivered && pragueDateParts(deliveredSource)) {
      expectedLabel = 'Odesláno';
      expectedValue = formatDate(deliveredSource);
    } else if (isReadyPickup && pragueDateParts(pickupReadySource)) {
      expectedLabel = 'Doručeno na výdejní místo';
      expectedValue = formatDate(pickupReadySource);
    } else if (!isDelivered && !isReadyPickup && pragueDateParts(data.estimatedDeliveryAt)) {
      expectedLabel = data.pickupType ? 'Očekávané doručení na výdejní místo' : 'Předpokládané doručení';
      expectedValue = formatDate(data.estimatedDeliveryAt);
    }

    if (expectedLabel && expectedValue) {
      var expectedBox = el('div', 'fb-order-view__meta-item fb-order-view__meta-item--expected');
      expectedBox.appendChild(el('span', '', expectedLabel));
      expectedBox.appendChild(el('strong', '', expectedValue));
      meta.appendChild(expectedBox);
    }
    container.appendChild(meta);

    var pay = el('div', 'fb-order-view__payment');
    var payTop = el('div', 'fb-order-view__payment-top');
    payTop.appendChild(el('span', '', 'Platba'));
    payTop.appendChild(el('strong', '', payment.label));
    pay.appendChild(payTop);
    if (payment.method && payment.method !== payment.label) pay.appendChild(el('small', '', 'Způsob platby: ' + payment.method));
    pay.appendChild(el('p', '', payment.message));
    container.appendChild(pay);

    appendPickupCountdown(container, data, status, options);

    var hasTracking = !!(tracking.number || trackingUrl || carrier);
    if (hasTracking || status.showTracking) {
      var ship = el('div', 'fb-order-view__shipping');
      if (carrier) {
        var carrierBox = el('div');
        carrierBox.appendChild(el('span', '', 'Curier'));
        carrierBox.appendChild(el('strong', '', carrier));
        ship.appendChild(carrierBox);
      }
      if (tracking.number) {
        var trackBox = el('div');
        trackBox.appendChild(el('span', '', 'Sledovací číslo'));
        trackBox.appendChild(el('strong', '', tracking.number));
        ship.appendChild(trackBox);
      }
      if (trackingUrl) {
        var isGls = /gls/i.test(String(carrier || ''));
        if (status.key === 'in_transit' || status.key === 'out_for_delivery') {
          var actionBox = el('div');
          actionBox.style.gridColumn = '1 / -1';
          actionBox.appendChild(el('span', '', 'Informace o doručení'));
          actionBox.appendChild(el('strong', '', isGls
            ? 'Aktuální informace a předpokládaný čas doručení najdete na webu GLS. Může být vyžadováno PSČ.'
            : 'Aktuální informace a předpokládaný čas doručení najdete na webu přepravce. Může být vyžadováno PSČ.'));
          ship.appendChild(actionBox);
        }
        var buttonLabel = isGls ? 'OTEVŘÍT SLEDOVÁNÍ GLS'
          : (carrier ? carrier.toUpperCase() + ' OTEVŘÍT SLEDOVÁNÍ' : 'SLEDOVAT ZÁSILKU');
        var button = el('a', 'fb-order-track-button', buttonLabel);
        button.href = trackingUrl;
        button.target = '_blank';
        button.rel = 'noopener noreferrer';
        // A nyomkövetési gomb a futáradatok elé kerül, hogy könnyen megtalálható legyen.
        ship.prepend(button);
      }
      // A futár oldalára vezető hivatkozás az első imaginiernyőn is könnyebben elérhető.
      container.insertBefore(ship, meta);
    }

    appendWhatsApp(container, options.whatsappUrl, data, status, status.problem || status.key === 'delivered');
    container.hidden = false;
  }

  function noMatchMessage(secondType) {
    var labels = {
      email: 'e-mailová adresa', phone: 'telefonní číslo', postal_code: 'PSČ', order_number: 'číslo objednávky'
    };
    var label = labels[secondType] || 'druhý údaj';
    return 'Zadané údaje neodpovídají žádné objednávce. Zkontrolujte zejména ' + label + '. Z bezpečnostních důvodů neuvádíme, který údaj je chybný.';
  }

  window.FansBrandsOrderSupport = {
    version: '20.3.0',
    fieldMeta: FIELD_META,
    normalize: normalize,
    validate: validate,
    secondaryKeys: secondaryKeys,
    configureInput: configureInput,
    safeUrl: safeUrl,
    statusModel: statusModel,
    paymentModel: paymentModel,
    pickupModel: pickupModel,
    renderOrder: renderOrder,
    noMatchMessage: noMatchMessage
  };
})();
